import React, {useContext, useEffect, useRef, useState} from "react";
import {TranslateContext} from "../../../../context/TranslateContext";
import {AuthContext} from "../../../../context/AuthContext";
import {getModificheKpiApi, getStrutturaModificaSelApi} from "../../services/KpiServices";
import StoricoModificheKpiView from "./StoricoModificheKpiView";

export default function StoricoModificheKpiController({
                                                idKpi,
                                                idTipoImportDati
                                            }) {

    const [modificheKpi, setModificheKpi] = useState([]);
    const [strutturaKpi, setStrutturaKpi] = useState([]);
    const [modificaSel, setModificaSel] = useState();
    const [modifichePresenti, setModifichePresenti] = useState(false);

    const {annoKpi} = useContext(AuthContext);
    const formikRef = useRef();
    const {translate} = useContext(TranslateContext);

    async function getModificheKpi() {
        const response = await getModificheKpiApi(idKpi, idTipoImportDati);
        setModificheKpi(response.data.data.modifiche);
    }

    useEffect(() => {
        if (idKpi && idKpi !== '' && idTipoImportDati && idTipoImportDati !== '') {
            getModificheKpi();
        }
    }, [idKpi, idTipoImportDati, annoKpi]);

    async function getStrutturaModificaSel() {
        const response = await getStrutturaModificaSelApi(idKpi, modificaSel, idTipoImportDati);
        let modPresenti = false;
        let modSel = response.data.data;
        if (modSel) {
            // Aggiorno la struttura con le modifiche alle celle effettuate alla data selezionata
            let strNew = JSON.parse(modSel.struttura);
            for (let i = 0; i < strNew.length; i++) {
                let livello = strNew[i];
                for (let l = 0; l < livello.sottolivelli.length; l++) {
                    let sottolivello = livello.sottolivelli[l];
                    for (let j = 0; j < sottolivello.elementi.length; j++) {
                        let elemento = sottolivello.elementi[j];

                        // Controllo se la cella corrente è tra quella modificate
                        let celleModFiltrate = modSel.modifiche.filter((m) => m.cella === elemento.cella);
                        if (celleModFiltrate.length > 0) {
                            let cellaMod = celleModFiltrate[0];
                            elemento.valore = cellaMod.valore + ' -> ' + cellaMod.valoreNew;
                            elemento.modificato = true;

                            modPresenti = true;

                            // TODO capire per le celle di tipo lista
                        }
                    }
                }
            }
            setStrutturaKpi(strNew);
            setModifichePresenti(modPresenti);
        }
    }

    useEffect(() => {
        if (modificaSel) {
            if (modificaSel !== '') {
                getStrutturaModificaSel();
            } else {
                setStrutturaKpi([]);
            }
        }
    }, [modificaSel]);

    return (
        <StoricoModificheKpiView
            strutturaKpi={strutturaKpi}
            translate={translate}
            modificheKpi={modificheKpi}
            formikRef={formikRef}
            modificaSel={modificaSel}
            modifichePresenti={modifichePresenti}
            setModificaSel={setModificaSel}
        />
    );
}